import React from "react"
// import {
//   HelpScreen
// } from "../../screens"
// import { createNativeStackNavigator } from "@react-navigation/native-stack"
import { createStackNavigator } from "@react-navigation/stack"

export type HelpNavigatorParamList = {
  'Help.Help': undefined
}

// const Stack = createNativeStackNavigator<HelpNavigatorParamList>()
const Stack = createStackNavigator<HelpNavigatorParamList>()

export const HelpStack = {
  index: 0,
  routes: [
    { name: 'Help.Stack', state: { index: 0, routes: [{ name: 'Help.Help' }] } }
  ]
};

export const HelpNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        cardStyle: { flex: 1 },
        headerShown: false,
        headerBackTitleVisible: false,
        headerTitleAlign: "left",
        headerTitleContainerStyle: { marginLeft: 0 }
      }}
      // initialRouteName="Help.Help"
    >
      {/* <Stack.Screen name="Help.Help" component={HelpScreen} /> */}
    </Stack.Navigator>
  )
}
